var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiInfoCircleBoldLtr = function SvgUiInfoCircleBoldLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.525 39.5c1.424 0 2.583 1.064 2.624 2.391l.001.073v30.772c0 1.36-1.175 2.464-2.625 2.464-1.424 0-2.583-1.064-2.624-2.391l-.001-.073V41.964c0-1.36 1.175-2.464 2.625-2.464m0-6.3a4.725 4.725 0 1 0 0-9.45 4.725 4.725 0 0 0 0 9.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 50C8 26.804 26.804 8 50 8s42 18.804 42 42-18.804 42-42 42S8 73.196 8 50m78.967 0c0-20.416-16.55-36.967-36.967-36.967S13.033 29.583 13.033 50 29.583 86.967 50 86.967 86.967 70.416 86.967 50",
    clipRule: "evenodd"
  })));
};
export default SvgUiInfoCircleBoldLtr;